import { G as i } from "../chunks/GenColors-12ec1caa.mjs";
import p from "md5";
/**
 * @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const h = function(a) {
  let t = a.toLowerCase();
  t.match(/^([0-9a-f]{4}-?){8}$/) === null && (t = p(t)), t = t.replace(/[^0-9a-f]/g, "");
  const o = 6, l = i(o);
  function f(r, c) {
    let s = 0;
    const e = [];
    for (let n = 0; n < r.length; n++)
      e.push(parseInt(r.charAt(n), 16) % 16);
    for (const n in e)
      s += e[n];
    return parseInt(parseInt(s, 10) % c, 10);
  }
  return l[f(t, o * 3)];
};
export {
  h as default
};
